// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Home';
import SunGpt from './sungptSignup';
import SunGptLogin from './sungpt';
import SunGptPhone from './sungpt_phone';
import Suncheck from './checkapply';
import Suncheck2 from './checkapply2';
import Qna from './qna';
import Celebrity from './celebrity';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sungptSignup" element={<SunGpt />} />
        <Route path="/sungpt" element={<SunGptLogin />} />
        <Route path="/sungptPhone" element={<SunGptPhone />} />
        <Route path="/checkapply" element={<Suncheck />} />
        <Route path="/checkapply2" element={<Suncheck2 />} />
        <Route path="/qna" element={<Qna />} />
        <Route path="/celebrity" element={<Celebrity />} />
      </Routes>
    </Router>
  );
}

export default App;
